import React from "react";
import {InputLogin} from "src/component/Useful/Input/InputLogin";
import {ButtonCompany} from "src/component/Useful/Button/ButtonCompany";
import "./style/RecoveryPasswordCompany.scss"
import Icon from "src/component/Icon/Sprite";
import {ICONS} from "src/assets/sprite/iconsNames";
import {FormattedMessage, injectIntl} from "react-intl";
import {Col, Form, Row} from "antd";
import CompanyPicture from "../../../../assets/image/PictureLoginCompany.png";
import actions from "../../../../redux/auth/actions";
import {useDispatch} from "react-redux";
import {useLocation, useNavigate} from "react-router";

const {resetPassword} = actions

function RecoveryPasswordCompany() {

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [newPassword, setNewPassword] = React.useState(null)
    const [state, setState] = React.useState(false)
    const [toggleType, setToggleType] = React.useState(false)
    const [toggleIconPassword, setToggleIconPassword] = React.useState(false)



    const handleClick = () =>{
        if(newPassword){
            let otp = location.search.substring(5)
            let data = {
                newPassword: newPassword,
                otp:otp
            }
            dispatch(resetPassword(data))
            setState(true)
        }
    }

    const goTo = () => {
        navigate("/company/login")
    }

    const ShowPassword = () =>{
        setToggleType(!toggleType)
        setToggleIconPassword(!toggleIconPassword)
    }

    return(
        <div className={"containerRecoveryCompanyPassword"}>
            <div className="contentRecoveryCompanyPassword">
                <Row>
                    <Col md={{span: 12}} sm={{span: 20}} xs={{span: 24}}>
                        <div className={"image"}>
                            <img src={CompanyPicture} className={"side-image"}/>
                        </div>
                    </Col>
                    <Col md={{span: 8}} sm={{offset:2, span: 20}} xs={{span: 24}} className={"flex-column-center"}>
                        {
                            state === false ?
                            (
                                <div className={"contentRecoveryPasswordCompany"}>
                                    <header className={"padding-bottom-20"}>
                                        <h1><FormattedMessage id="RecoveryPassword_Header_title"/></h1>
                                        <p><FormattedMessage id="RecoveryPassword_Header_text"/></p>
                                    </header>

                                    <main>
                                        <p><FormattedMessage id="RecoveryPassword_Main_title"/></p>
                                        <Form>
                                            <Form.Item
                                                name={"password"}
                                                className="inline-block width-100"
                                            >
                                                <InputLogin type={toggleType ? "text" : "password"} className={"input"} prefix={<Icon name={ICONS.lock} size={[20,20]} className="opacity-50"/>} suffix={<div onClick={(e)=>ShowPassword()}><Icon name={toggleIconPassword ? ICONS.eye : ICONS.eye_hide} className="flex-center pointer" color="#C41A43" size={[20,20]}/></div>} placeholder="Inserire la password" onChange={(e) => setNewPassword(e.target.value)}/>
                                            </Form.Item>
                                        </Form>
                                    </main>
                                    <footer>
                                        <ButtonCompany block onClick={handleClick} icon={<Icon name={ICONS.tik} className="margin-5 opacity-50" size={[20,20]}/>} className={"flex-center"}>
                                            <FormattedMessage id="RecoveryPassword_Button"/>
                                        </ButtonCompany>
                                    </footer>
                                </div>
                            ):(
                                <div className={"containerConfirmNewPassword padding-left-70"}>
                                    <h1 className={"green"} ><FormattedMessage id="ConfirmNewPassword_title"/> </h1>
                                    <ButtonCompany onClick={goTo}>
                                        <FormattedMessage id="ConfirmNewPassword_button"/>
                                    </ButtonCompany>
                                </div>
                            )
                        }
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default injectIntl(RecoveryPasswordCompany)
